export default "/images/e58bd2dfc367a1e537b10878a500a9be.avif";